import BaseButton from 'components/atoms/baseButton';
import Section from 'components/molecules/section';

import MasterModal from '../masterModal';
import s from './styles.module.scss';
import { formSections } from './form-sections';
import { useNote } from './use-note';

import type { FC } from 'react';

interface CkdCcmClinicalModalProps {
  patientGuid: string;
  open: boolean;
  toggleOpen: () => void;
  onSubmit: (values: string) => void;
}

const CkdCcmClinicalModal: FC<CkdCcmClinicalModalProps> = ({
  patientGuid,
  open,
  toggleOpen,
  onSubmit,
}) => {
  if (!open) return null;

  const {
    currentStep,
    goToNextStep,
    goToPrevStep,
    setValue,
    errorSections,
    values,
    submit,
  } = useNote({
    patientGuid,
    onSubmit,
    toggleOpen,
  });

  return (
    <MasterModal
      isOpen={open}
      toggle={toggleOpen}
      title="CKD Assessment - SignalCCM"
      subTitle={`${formSections[currentStep].title} - ${currentStep + 1} of ${
        formSections.length
      }`}
      footer={
        <div className={s['footer-nav']}>
          {currentStep === formSections.length - 1 &&
            errorSections.length > 0 && (
              <p className={s['error-fields']} data-cy="modal-error">
                Missing fields in section(s): {errorSections.join(', ')}
              </p>
            )}
          <div className={s['footer-buttons']}>
            {currentStep !== 0 && (
              <BaseButton
                onClick={goToPrevStep}
                label="< Back"
                type="secondary"
                dataCy="back-btn"
              />
            )}
            {currentStep === formSections.length - 1 ? (
              <BaseButton
                disabled={Boolean(errorSections.length)}
                onClick={submit}
                label="Submit"
              />
            ) : (
              <BaseButton
                onClick={goToNextStep}
                label="Forward >"
                dataCy="forward-btn"
                type="secondary"
              />
            )}
          </div>
        </div>
      }
    >
      <div className="narrative-popup">
        <Section
          forms={formSections[currentStep].forms}
          setValue={setValue}
          values={values}
          canEditPage
        />
      </div>
    </MasterModal>
  );
};
export default CkdCcmClinicalModal;
